module.exports = __webpack_public_path__ + "img/bg2.eb76a94c.png";